<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>
    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar class="formCard" style="border-radius: 5px !important; padding-left: 0px" toggleable="lg" type="dark"
          variant="primary">
          <b-navbar-nav>
            <b-button @click="previousSalesView" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true">skip_previous</md-icon>Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Billing Location</b-navbar-brand>
        </b-navbar>

        <b-card class="formCard">
          <b-card-text>
            <!-- Add Update Form Input End-->
            <b-card class="gutr" v-if="addEditCard">
              <b-row class="align-items-end">
                <b-col md="12" v-if="BillingLocation.TypeofAdd !='Branch Pridel Billing Master'">
                  <h5>Update {{BillingLocation.branchName}} Branch Details</h5>
                </b-col>
                <b-col md="3">
                  <label>
                    Name
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="billingLocation" name="billingLocation"
                    v-model="BillingLocation.billingLocation" :disabled="BillingLocation.billingLocationId?true:false"
                    placeholder="Location Name"></b-form-input>
                  <span class="error" v-if="!BillingLocation.billingLocation">
                    {{
                    errorList.billingLocation
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Location Code
                    <span class="error"></span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="LocCode" name="LocCode"
                    v-model="BillingLocation.LocCode" placeholder="Location Code"></b-form-input>
                  <span class="error" v-if="!BillingLocation.LocCode">
                    {{
                    errorList.LocCode
                    }}
                  </span>
                </b-col>
                <b-col md="3" v-if="BillingLocation.TypeofAdd =='Branch Pridel Billing Master'">
                  <label>
                    Multi-Branch
                    <span class="error"></span>
                  </label>
                  <multi-select :options="$store.getters['common/getAllMultiBranchList']" :selected-options="items"
                    v-model="BillingLocation.multibranch" placeholder="Select Multi-Branch" :multiple="true"
                    @select="SelectMultiBranch"></multi-select>
                  <span class="error" v-if="!BillingLocation.multibranch">
                    {{
                    errorList.multibranch
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    State
                    <span class="error">*</span>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllStateList']"
                    v-model="BillingLocation.fk_state_id" option-value="stateId" option-text="stateName"
                    placeholder="Select State " @input="getGSTCode(BillingLocation.fk_state_id)"></model-list-select>
                  <span class="error" v-if="!BillingLocation.fk_state_id">
                    {{
                    errorList.fk_state_id
                    }}
                  </span>
                </b-col>
                <b-col md="3" v-if="BillingLocation.fk_state_id">
                  <label>
                    City
                    <span class="error">*</span>
                  </label>
                  <model-list-select :list="$store.getters['common/getAllCityList']"
                    v-model="BillingLocation.fk_city_id" option-value="city_id" option-text="city_name"
                    placeholder="Select City "></model-list-select>

                  <span class="error" v-if="!BillingLocation.fk_city_id">
                    {{
                    errorList.fk_city_id
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    PIN Code
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="PinCode" name="PinCode"
                    v-model="BillingLocation.PinCode" placeholder="PIN Code"></b-form-input>
                  <span class="error" v-if="!BillingLocation.PinCode">
                    {{
                    errorList.PinCode
                    }}
                  </span>
                </b-col>

                <b-col md="6">
                  <label>
                    Address
                    <span class="error">*</span>
                  </label>
                  <b-textarea size="sm" :formatter="capitalizeAll" id="address" name="address"
                    v-model="BillingLocation.address" placeholder="Address"></b-textarea>
                  <span class="error" v-if="!BillingLocation.address">
                    {{
                    errorList.address
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    GST No.(AAAAA1234A1Z5)
                    <span class="error">*</span>
                  </label>
                  <div class="row">
                    <div class="col-md-3">
                      <b-form-input :formatter="capitalizeAll" name="gstCode" id="gstCode"
                        v-model="BillingLocation.gstCode" disabled placeholder="GST Code"></b-form-input>
                    </div>
                    <div class="col-md-9">
                      <b-form-input :formatter="capitalizeAll" name="GSTN" id="GSTN" v-model="BillingLocation.GSTN"
                        placeholder="GST No" @keyup="GSTNValid()"></b-form-input>
                      <span class="error" v-if="!BillingLocation.GSTN || errorList.GSTN">
                        {{
                        errorList.GSTN
                        }}
                      </span>
                    </div>
                  </div>
                </b-col>
                <b-col md="3">
                  <label>
                    PAN(AAAAA1234A)
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" name="panNO" id="panNO" v-model="BillingLocation.panNO"
                    @keyup="PANValid()" placeholder="PAN NO"></b-form-input>
                  <span class="error" v-if="!BillingLocation.panNO || errorList.panNO">
                    {{
                    errorList.panNO
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    TAN(AAAAA1234A)
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" name="TAN" id="TAN" v-model="BillingLocation.TAN"
                    @keyup="TANValid()" placeholder="TAN NO"></b-form-input>
                  <span class="error" v-if="!BillingLocation.TAN || errorList.TAN">
                    {{
                    errorList.TAN
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    CIN
                    <span class="error">*</span>
                  </label>
                  <b-form-input :formatter="capitalizeAll" name="CIN" id="CIN" v-model="BillingLocation.CIN"
                    placeholder="CIN NO"></b-form-input>
                  <span class="error" v-if="!BillingLocation.CIN">
                    {{
                    errorList.CIN
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Email
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="emailId" name="emailId"
                    v-model="BillingLocation.emailId" @input="checkEmailID()" placeholder="Email ID"></b-form-input>
                  <span class="error" v-if="!BillingLocation.emailId || errorList.emailId">
                    {{
                    errorList.emailId
                    }}
                  </span>
                </b-col>
                <b-col md="3">
                  <label>
                    Tele. No.
                    <span class="error">*</span>
                  </label>
                  <b-form-input size="sm" :formatter="capitalizeAll" id="Telephone" name="Telephone"
                    v-model="BillingLocation.Telephone" placeholder="Telephone No"></b-form-input>
                  <span class="error" v-if="!BillingLocation.Telephone">
                    {{
                    errorList.Telephone
                    }}
                  </span>
                </b-col>
                <b-col md="3" v-if="BillingLocation.TypeofAdd =='Branch Pridel Billing Master'">
                  <label>
                    Status :
                    <!-- {{BillingLocation.isBillingLocationActive}} -->
                    <span class="error">*</span>
                  </label>
                  <md-switch :id="'approval'+BillingLocation.isBillingLocationActive" name="approval" class="md-primary"
                    :value="BillingLocation.isBillingLocationActive==true?true:false"
                    @change="activateBillingLocation()">
                    <h6>
                      <b-badge
                        :variant="BillingLocation.isBillingLocationActive==1?'success':'danger'">{{BillingLocation.isBillingLocationActive==1?"Active":"In-Active"
                        }}</b-badge>
                    </h6>
                  </md-switch>
                </b-col>
                <b-col md="12">
                  <center>
                    <b-button style="margin-bottom: 0.3rem" variant="success" @click="addBillingLocation" class="mt-2"
                      id="addButtonLoader">
                      {{
                      BillingLocation. billingLocationId != "" ? "Update" : "Save"
                      }}
                    </b-button>
                  </center>
                  <md-spinner md-indeterminate id="loader" style="display: none"></md-spinner>
                </b-col>
              </b-row>
            </b-card>
            <!-- Add Update Form Input End-->

            <div class="mt-3">
              <!-- Search Form Input Start-->
              <b-row>
                <b-col md="10" class="my-1">
                  <b-form-group>
                    <b-input-group>
                      <b-form-input :formatter="capitalizeAll" @input="debounceSearch" v-model="filter"
                        placeholder="Type to Search Billing Location and Code" ref="search" />
                      <b-input-group-append>
                        <b-button :disabled="!filter" @click="filterClear">Clear</b-button>
                      </b-input-group-append>
                    </b-input-group>
                  </b-form-group>
                </b-col>
                <b-col md="2">
                  <b-button variant="outline-primary" @click="addEditCardFunc()" size="sm">Add</b-button>

                  <b-button size="sm" class="ml-2" :disabled="ExcelBtnName != 'Export as Excel' ? true : false"
                    @click="getData('Excel')" variant="outline-info"> {{ ExcelBtnName }}
                    <b-spinner v-if="ExcelBtnName != 'Export as Excel'" small
                      label="Small Spinner"></b-spinner></b-button>

                  <h5 class="text-muted pull-right mt-2 ml-3">
                    <small v-if="isLoading == false">{{ totalRows }} Entries</small>
                  </h5>
                </b-col>
              </b-row>
              <!-- Search Form Input End-->
              <!-- Main table element -->
              <div class="table-responsive tableMain">
                <b-table show-empty stacked="md" :items="BillingLocationList" :fields="fields"
                  :current-page="currentPage" :per-page="perPage" :filter="filter" :sort-by.sync="sortBy"
                  :sort-desc.sync="sortDesc" :sort-direction="sortDirection" @filtered="onFiltered" responsive
                  primary-key="billingLocationId" class="position-relative">
                  <template slot="billingLocationId" slot-scope="row0">
                    <span>
                      {{
                      row0.index + 1 + (currentPage - 1) * perPage
                      }}
                    </span>
                  </template>
                  <template slot="billingLocation" slot-scope="row1">
                    <span>
                      <b>Name:</b>
                      {{ row1.item.billingLocation }}
                    </span>
                    <br />
                    <span>
                      <b>Code:</b>
                      {{ row1.item.LocCode }}
                    </span>
                    <br />
                    <span>
                      <b>Email ID:</b>
                      {{ row1.item.emailId }}
                    </span>
                    <br />
                    <span>
                      <b>Telephone No.:</b>
                      {{ row1.item.Telephone }}
                    </span>
                  </template>
                  <template slot="LocCode" slot-scope="row1">
                    <span>
                      <b>Address:</b>
                      {{ row1.item.address }}
                    </span>
                    <br />
                    <span>
                      <b>State:</b>
                      {{ row1.item.state_name }}
                    </span>
                    <br />
                    <span>
                      <b>City:</b>
                      {{ row1.item.city_name }}
                    </span>
                    <br />
                    <span>
                      <b>Pin Code:</b>
                      {{ row1.item.PinCode }}
                    </span>
                  </template>
                  <template slot="panNO" slot-scope="row1">
                    <span>
                      <b>GST Code:</b>
                      {{ row1.item.gstCode }}
                    </span>
                    <br />
                    <span>
                      <b>GST NO:</b>
                      {{ row1.item.GSTN }}
                    </span>
                    <br />
                    <span>
                      <b>PAN NO:</b>
                      {{ row1.item.panNO }}
                    </span>
                    <br />
                    <span>
                      <b>TAN NO:</b>
                      {{ row1.item.TAN }}
                    </span>
                    <br />
                    <span>
                      <b>CIN:</b>
                      {{ row1.item.CIN }}
                    </span>
                  </template>
                  <template slot="branchName" slot-scope="row3">
                    <span v-if="row3.item.branchName">
                      <b-button v-for="(branch_name, branch_index) in row3.item.branchName.split(',')"
                        :key="branch_index" variant="outline-primary"
                        @click="updateBranchDetails(branch_name,row3.item)" id="addButtonLoader" size="sm"
                        style="font-size: 0.675rem" class="mt-2">{{branch_name}}</b-button>
                    </span>
                    <span v-else>NA</span>
                  </template>
                  <template slot="isBillingLocationActive" slot-scope="row3">
                    <!-- <h6>
                      <b-badge
                        :variant="row3.item.isBillingLocationActive==1?'success':'danger'"
                      >{{row3.item.isBillingLocationActive==1?"Active":"In-Active" }}</b-badge>
                    </h6> -->

                    <div v-if="adminToggle == 'Admin'" :id="'row' + row3.item.billingLocationId">
                      <md-switch :id="'approval' + row3.item.billingLocationId" name="approval" class="md-primary"
                        :value="row3.item.isBillingLocationActive == 1 ? true : false"
                        @change="activateUser(row3.item)">
                        <h6>
                          <br />
                          <b-badge style="margin-left: -45px">{{
                            row3.item.isBillingLocationActive == 1 ? "Active" : "In-Active"
                            }}</b-badge>
                        </h6>
                      </md-switch>
                    </div>
                    <div v-else :id="'row' + row3.item.billingLocationId">
                      <h6>
                        <b-badge>{{
                          row3.item.isBillingLocationActive == 1 ? "Active" : "In-Active"
                          }}</b-badge>
                      </h6>
                    </div>

                  </template>
                  <template slot="creationTime" slot-scope="row3">{{row3.item.creationTime}}</template>

                  <template slot="action" slot-scope="row2">
                    <b-button variant="outline-primary" @click="editLocation(row2.item)" id="addButtonLoader"
                      size="sm">Update</b-button>
                  </template>
                </b-table>
              </div>
              <b-row>
                <b-col md="12" class="my-1">
                  <b-pagination limit="25" :total-rows="totalRows" :per-page="perPage" v-model="currentPage"
                    class="my-0 pull-right" />
                </b-col>
              </b-row>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>
    <md-dialog-alert :md-content="alert.content" :md-ok-text="alert.ok" ref="addPop"></md-dialog-alert>
  </div>
</template>

<script>
import DatePicker from "vue2-datepicker";
import axios from "axios";
import moment from "moment";
import { ModelListSelect, MultiSelect } from "vue-search-select";
// import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import { URL_BASE, URL_BASE_DOC } from "../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../helper/filters";
import { globalPermissionStatus } from "../../helper/collection";
import CommonService from "../../services/CommonService.js";
// import Multiselect from "vue-multiselect";
import CustomLoader from "../common/customLoader.vue";

export default {
  beforeMount() {
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != ""
    ) {
      this.$store.dispatch(
        "setCurrentRoute",
        "/freightForward/newBillingLocation"
      );
      if (globalPermissionStatus("locaionMaster") != "Disabled") {
        this.$sessionsStorage.set(
          "PermissionStatus",
          globalPermissionStatus("locaionMaster")
        );
      } else {
        this.$router.push({
          path: "/dashboard"
        });
      }
      this.$store.dispatch(
        "common/setAllStateList",
        JSON.stringify({
          itemCode: "StateList"
        })
      );
      this.$store.dispatch(
        "common/setAllMultiBranchList",
        JSON.stringify({
          filter: "MultiBranchList",
          active: "all"
        })
      );
      this.getData("Normal");
    } else {
      this.$router.push({
        path: "/Login/"
      });
    }
  },
  data() {
    return {
      ExcelBtnName: "Export as Excel",
      addEditCard: false,
      isLoading: false,
      fields: [
        {
          key: "billingLocationId",
          label: "SN.",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "billingLocation",
          label: "Location Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "LocCode",
          label: "Address",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "panNO",
          label: "Additional Details",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "branchName",
          label: "Branches",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "isBillingLocationActive",
          label: "Status",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "creationTime",
          label: "Date",
          sortable: true,
          sortDirection: "desc"
        },
        {
          key: "action",
          label: "Actions",
          sortable: true,
          sortDirection: "desc"
        }
      ],
      currentPage: 1,
      perPage: 10,
      totalRows: "",
      pageOptions: [5, 10, 15],
      sortBy: null,
      sortDesc: false,
      sortDirection: "desc",
      filter: null,
      modalInfo: { title: "", content: "" },
      alert: {
        content: "Added Succesfully",
        ok: "ok"
      },
      // excelUpload: "",
      branchLocation: "",
      branchName: "",
      items: [],
      BillingLocation: {
        billingLocationId: "",
        billingLocation: "",
        // LocCode: "",
        multibranch: "",
        fk_state_id: "",
        fk_city_id: "",
        state_name: "",
        city_name: "",
        PinCode: "",
        gstCode: "",
        GSTN: "",
        panNO: "",
        TAN: "",
        CIN: "",
        emailId: "",
        Telephone: "",
        address: "",
        isBillingLocationActive: true,
        TypeofAdd: "Branch Pridel Billing Master"
      },
      BillingLocationError: [
        "Please Enter Location Name",
        // "Please Enter Location Code",
        "Please Enter State",
        "Please Enter City",
        "Please Enter PIN Code",
        "Please Enter GST COde",
        "Please Enter GST NO",
        "Please Enter TAN NO",
        "Please Enter PAN NO",
        "Please Enter CIN NO",
        "Please Enter Email ID",
        "Please Enter Telephone NO",
        "Please Enter Address"
      ],
      errorList: {
        billingLocation: "",
        // LocCode: "",
        multibranch: "",
        fk_state_id: "",
        fk_city_id: "",
        PinCode: "",
        gstCode: "",
        GSTN: "",
        panNO: "",
        TAN: "",
        CIN: "",
        emailId: "",
        Telephone: "",
        address: ""
      },

      BillingLocationList: [],
      validate: true,

      indexNew: "",
      deleteId: "",
      itemObj: {},
      adminToggle: this.$sessionsStorage.get("designation")
    };
  },
  filters: {
    moment(date) {
      return DateFormat(date);
    }
  },
  mounted() {},

  beforeDestroy() {},

  destroyed() {},

  components: {
    DatePicker,
    ModelListSelect,
    // Loading,
    MultiSelect,
    CustomLoader,
  },

  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key };
        });
    }
  },
  methods: {
    SelectMultiBranch(items, lastSelectItem) {
      // alert("helwo")
      console.log("Priyanshu Singh=>", items[0]);
      // this.items.push(items);
      this.items = items;
      this.BillingLocation.multibranch = items;
      // console.log('item=>',this.items);
    },
    clearErrVal() {
      this.branchLocation = "";
      this.branchName = "";
      this.BillingLocation = {
        billingLocationId: "",
        billingLocation: "",
        // LocCode: "",
        multibranch: "",
        fk_state_id: "",
        fk_city_id: "",
        state_name: "",
        city_name: "",
        PinCode: "",
        gstCode: "",
        GSTN: "",
        panNO: "",
        TAN: "",
        CIN: "",
        emailId: "",
        Telephone: "",
        address: "",
        isBillingLocationActive: true,
        TypeofAdd: "Branch Pridel Billing Master"
      };
      this.errorList = {
        billingLocation: "",
        // LocCode: "",
        // multibranch: "",
        fk_state_id: "",
        fk_city_id: "",
        PinCode: "",
        gstCode: "",
        GSTN: "",
        panNO: "",
        TAN: "",
        CIN: "",
        emailId: "",
        Telephone: "",
        address: ""
      };
    },

    updateBranchDetails(branch_name, PridleBB_Items) {
      this.isLoading = true;
      let branchId = "";
      let branchName = "";
      this.clearErrVal();
      this.addEditCard = true;
      this.$store.getters["common/getAllMultiBranchList"].forEach(BL_Val => {
        if (BL_Val.text == branch_name) {
          branchId = BL_Val.value;
          branchName = BL_Val.text;
        }
      });
      let payload = {
        itemCode: "get_Single_Billing_branch_Location_Details",
        branchId: branchId,
        branchName: branchName
      };
      payload = JSON.stringify(payload);
      // console.log("Happpy SIngh",payload)
      // return false;
      if (this.validate != false) {
        CommonService.getAllProformaInvoice(payload)
          .then(response => {
            const { data, status, statusText } = response;
            console.log(
              "data.Single_Billing_branch_Deatails=>",
              data.Single_Billing_branch_Deatails
            );
            if (data.Single_Billing_branch_Deatails) {
              const Single_Billing_branch_Deatails =
                data.Single_Billing_branch_Deatails;
              Single_Billing_branch_Deatails.forEach(B_val => {
                this.BillingLocation = {
                  billingLocationId: PridleBB_Items.billingLocationId,
                  billingLocation: PridleBB_Items.billingLocation,
                  LocCode: PridleBB_Items.LocCode,
                  fk_state_id: B_val.fk_state_id,
                  fk_city_id: B_val.fk_city_id,
                  state_name: B_val.state_name,
                  city_name: B_val.city_name,
                  PinCode: B_val.PinCode,
                  gstCode: B_val.gstCode,
                  GSTN: B_val.GSTN,
                  panNO: B_val.panNO,
                  TAN: B_val.TAN,
                  CIN: B_val.CIN,
                  emailId: B_val.emailId,
                  Telephone: B_val.Telephone,
                  address: B_val.address_bl,
                  TypeofAdd: "Branch Pickup Location Master",
                  branchLocation: branchId,
                  branchName: branchName
                };
                if (B_val.fk_state_id) {
                  this.getGSTCode(B_val.fk_state_id);
                }
                console.log(this.BillingLocation, " this.BillingLocation");
              });
            }
            this.setFocus();
            this.isLoading = false;
            // this.$refs["addPop"].open();
          })
          .catch(error => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },
    editLocation(item) {
      this.clearErrVal();
      this.addEditCard = true;
      if (item.fk_state_id) {
        this.getGSTCode(item.fk_state_id);
      }
      this.items = [];
      let branchLocation = [];
      if (item.branchLocation.indexOf(",") >= 0) {
        branchLocation = item.branchLocation.split(",");
      } else {
        branchLocation.push(item.branchLocation);
      }
      branchLocation.forEach(B_val => {
        this.$store.getters["common/getAllMultiBranchList"].forEach(BL_Val => {
          if (B_val == BL_Val.value) {
            let obj = {
              text: BL_Val.text,
              value: BL_Val.value
            };
            this.items.push(obj);
          }
        });
      });

      console.log("Priyanshu items=>", item);
      console.log("This items=>", this.items);
      this.branchLocation = item.branchLocation;
      this.branchName = item.branchName;
      item.TypeofAdd = "Branch Pridel Billing Master";
      this.BillingLocation = item;
      this.setFocus();
    },
    addEditCardFunc() {
      this.clearErrVal();
      this.addEditCard = !this.addEditCard;
    },
    setFocus: function() {
      // Note, you need to add a ref="search" attribute to your input.
      this.$refs.search.focus();
    },
    activateBillingLocation() {
      // this.BillingLocation.isBillingLocationActive = !this.BillingLocation
      //   .isBillingLocationActive;
      // alert(this.BillingLocation.isBillingLocationActive)
      if (
        this.BillingLocation.isBillingLocationActive == 1 ||
        this.BillingLocation.isBillingLocationActive == true
      ) {
        this.BillingLocation.isBillingLocationActive = false;
      } else if (
        this.BillingLocation.isBillingLocationActive == 0 ||
        this.BillingLocation.isBillingLocationActive == false
      ) {
        this.BillingLocation.isBillingLocationActive = true;
      }
    },
    getGSTCode(state_id) {
      // alert(state_id)
      if (state_id) {
        let gstCode = this.$store.getters["common/getAllStateList"].filter(
          val => {
            // alert(val.stateId)
            if (val.stateId == state_id) {
              this.BillingLocation.gstCode = val.gstCode;
              this.BillingLocation.state_name = val.stateName;
              this.$store.dispatch(
                "common/setAllCityList",
                JSON.stringify({
                  itemCode: "CityList",
                  state_code: val.stateCode
                })
              );
            }
          }
        );
      } else {
        this.BillingLocation.gstCode = "";
      }

      // console.log("gstCode=>",gstCode,this.$store.getters['common/getAllStateList'])
      // console.log("gstCode=>", this.BillingLocation.gstCode,this.$store.getters['common/getAllStateList'])
    },
    checkEmailID() {
      let emailreg = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/;
      if (emailreg.test(this.BillingLocation.emailId)) {
        this.errorList.emailId = "";
      } else {
        this.errorList.emailId = "Please Enter Valid Email ID";
        this.validate = false;
      }
    },
    GSTNValid() {
      var gstinformat = new RegExp(
        "^[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$"
      );

      if (gstinformat.test(this.BillingLocation.GSTN)) {
        this.errorList.GSTN = "";
      } else {
        this.errorList.GSTN = "Please Enter Valid GSTN";
        this.validate = false;
      }
    },
    PANValid() {
      var paninformat = new RegExp("^[A-Z]{5}[0-9]{4}[A-Z]{1}$");

      if (paninformat.test(this.BillingLocation.panNO)) {
        this.errorList.panNO = "";
      } else {
        this.errorList.panNO = "Please Enter Valid PAN No.";
        this.validate = false;
      }
    },
    TANValid() {
      var taninformat = new RegExp("^[A-Z]{4}[0-9]{5}[A-Z]{1}$");

      if (taninformat.test(this.BillingLocation.TAN)) {
        this.errorList.TAN = "";
      } else {
        this.errorList.TAN = "Please Enter Valid TAN No.";
      }
    },
    previousSalesView() {
      window.history.go(-1);
    },
    debounceSearch(event) {
      clearTimeout(this.debounce);
      this.debounce = setTimeout(() => {
        this.getData("Normal");
      }, 1000);
    },
    filterClear() {
      this.filter = "";
      this.getData("Normal");
    },
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    JqueryFun() {
      return $(function() {
        return $("#portLocationNew").DataTable();
      });
    },
    validateBillingLocation() {
      let validate_new = true;
      Object.keys(this.errorList).map((x, index) => {
        if (
          this.BillingLocation[x] == "" ||
          this.BillingLocation[x] == undefined ||
          this.BillingLocation[x] == null
        ) {
          this.errorList[x] = this.BillingLocationError[index];
          validate_new = false;
        }
      });
      if (validate_new != true) {
        this.validate = false;
        return;
      } else {
        this.validate = true;
      }
    },

    addBillingLocation() {
      this.validateBillingLocation();
      this.PANValid();
      this.GSTNValid();
      this.checkEmailID();
      if (this.validate == false) return false;
      this.isLoading = true;

      let gstCode = this.$store.getters["common/getAllStateList"].filter(
        val => {
          if (val.stateId == this.BillingLocation.fk_state_id) {
            this.BillingLocation.gstCode = val.gstCode;
            this.BillingLocation.state_name = val.stateName;
          }
        }
      );

      let cityCode = this.$store.getters["common/getAllCityList"].filter(
        cityVal => {
          // alert(val.stateId)
          if (cityVal.city_id == this.BillingLocation.fk_city_id) {
            this.BillingLocation.city_name = cityVal.city_name;
          }
        }
      );
      if (
        !this.BillingLocation.branchLocation &&
        !this.BillingLocation.branchName
      ) {
        this.BillingLocation.branchLocation = "";
        this.BillingLocation.branchName = "";
        this.items.forEach(item_val => {
          if (this.BillingLocation.branchLocation) {
            this.BillingLocation.branchLocation =
              this.BillingLocation.branchLocation + "," + item_val.value;
            this.BillingLocation.branchName =
              this.BillingLocation.branchName + "," + item_val.text;
          } else {
            this.BillingLocation.branchLocation = item_val.value;
            this.BillingLocation.branchName = item_val.text;
          }
        });
      }
      // console.log("this.BillingLocation=>",this.BillingLocation);return false;

      let payload = {
        itemCode: "Add_Billing_Location_Details",
        BillingLocation: this.BillingLocation
      };
      payload = JSON.stringify(payload);
      // console.log("Happpy SIngh",payload)
      // return false;
      if (this.validate != false) {
        CommonService.getAllProformaInvoice(payload)
          .then(response => {
            const { data, status, statusText } = response;
            if (
              data.billingLocationId != "" &&
              data.billingLocationId != undefined
            ) {
              if (data.find == 1 || data.find == 2) {
                this.alert.content = data.MSG;
              } else {
                this.alert.content = data.MSG;
              }
              this.addEditCardFunc();
              this.getData("Normal");
            } else {
              this.alert.content = data.MSG;
            }
            this.isLoading = false;
            this.$refs["addPop"].open();
          })
          .catch(error => {
            console.log("Catch on Proforma Error: ", error);
          });
      }
    },

    getData(type) {
      this.isLoading = true;
      let payload = {
        itemCode: "MasterBillingLocationList",
        type: type,
      };
      if(type == "Excel"){
        this.ExcelBtnName = "Downloading...." ;
      }
      CommonService.getAllProformaInvoice(payload)
        .then(response => {
          const { data, status, statusText } = response;
          if (status == 200 && data) {
            if (type == "Excel") {
              if (data.BillingLocationList.length > 0) {
                this.BillingLocationList = data.BillingLocationList;
                this.totalRows = data.BillingLocationList.length;
                this.ExcelBtnName = "Export as Excel";
              }
              console.log("data.excelName => ", data.excelName);
              window.location.href = `https://uploadsp.pridel.com/Pridel_Reports/` + data.excelName;
            } else {
              if (data.BillingLocationList.length > 0) {
                this.BillingLocationList = data.BillingLocationList;
                this.totalRows = data.BillingLocationList.length;
                console.log(" Billing Location List response=>", data);
              }
            }
          } else {
            this.BillingLocationList = [];
          }
          this.isLoading = false;
        })
        .catch(error => {
          console.log("Catch on Billing Location List Error: ", error);
        });
    },

    activateUser(item, index) {
      // $("#approval" + id).val();

      this.itemObj = item;
      this.indexNew = index;

      this.deleteId = item.billingLocationId;

      this.itemObj.isBillingLocationActive = this.itemObj.isBillingLocationActive == 1 ? 0 : 1;
      let paylod = {
        tableName: "pridel_billing_location_master",
        tableId: "billingLocationId",
        tableIsActive: "isBillingLocationActive",
        value1: this.itemObj.isBillingLocationActive,
        tableVal: this.deleteId,
        isMailSend:'No',
        manual:'No',
      };

      
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_Master/activateUser.php`,
        data: JSON.stringify(paylod),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          console.log("Salil Result => ", result);
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            this.getData("Normal");
          }
        })
        .catch((error) => {});

      // this.alert.content = true
      //   ? "Are you sure you want to Activate this User?"
      //   : "Are you sure you want to Deactivate this User?";
      // this.$refs["addPop6"].open();
    },
  }
};
</script>

<style>
.md-direction-bottom-right {
  width: 30% !important;
}
.mrgtop-2per {
  margin-top: 1%;
}
.mrgtop-5px {
  margin-top: 0px;
}
.center {
  text-align: center;
}
.heght-1px {
  height: 1px;
}

.b-form-input-container {
  margin: 4px 0 12px !important;
}
.md-button-color {
  background-color: #607d8d !important;
}

.md-button-color-toggle {
  background-color: rgba(153, 153, 153, 0.4) !important;
}

.activeClass {
  display: none;
}
.error {
  color: red;
}
</style>


// WEBPACK FOOTER //
// billingLocationMaster.vue?3e95aa47